/**
 * EndIntegration Route - React Router v7
 *
 * Route: /finalizar-integracion
 * Effect: closes the popup window; no data fetching.
 */
/* eslint-disable @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-throw-literal, @typescript-eslint/strict-boolean-expressions, @typescript-eslint/prefer-nullish-coalescing, no-console */
import EndIntegration from './index.js'

export async function loader() {
  return {__RR7__: true}
}

export function Component() {
  return <EndIntegration />
}

Component.displayName = 'EndIntegrationRoute'
